var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClientScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1016_39100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C3.44772 1 3 1.44772 3 2V16C3 16.5523 3.44772 17 4 17H14C14.5523 17 15 16.5523 15 16V6L10 1H4ZM10 2V6H14L10 2Z",
    fill: "#6E8CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4341 12.6519H12.314C12.2889 13.1961 12.1421 13.6759 11.8735 14.0913C11.605 14.5067 11.2326 14.8307 10.7563 15.0635C10.2837 15.2926 9.7251 15.4072 9.08057 15.4072C8.55778 15.4072 8.09049 15.3195 7.67871 15.144C7.27051 14.9686 6.92318 14.7161 6.63672 14.3867C6.35384 14.0573 6.13721 13.658 5.98682 13.189C5.84001 12.7199 5.7666 12.1917 5.7666 11.6045V11.1802C5.7666 10.5929 5.84359 10.0648 5.99756 9.5957C6.15511 9.12305 6.37712 8.72201 6.66357 8.39258C6.95361 8.05957 7.30094 7.80534 7.70557 7.62988C8.11019 7.45443 8.55957 7.3667 9.05371 7.3667C9.73405 7.3667 10.3088 7.48844 10.7778 7.73193C11.2469 7.97542 11.6104 8.31022 11.8682 8.73633C12.126 9.15885 12.2782 9.64046 12.3247 10.1812H10.4448C10.4377 9.88753 10.3875 9.64225 10.2944 9.44531C10.2013 9.24479 10.0545 9.0944 9.854 8.99414C9.65348 8.89388 9.38672 8.84375 9.05371 8.84375C8.82096 8.84375 8.61865 8.88672 8.44678 8.97266C8.2749 9.05859 8.13167 9.19466 8.01709 9.38086C7.90251 9.56706 7.81657 9.80876 7.75928 10.106C7.70557 10.3996 7.67871 10.7541 7.67871 11.1694V11.6045C7.67871 12.0199 7.70378 12.3743 7.75391 12.668C7.80404 12.9616 7.8846 13.2015 7.99561 13.3877C8.10661 13.5739 8.24984 13.7118 8.42529 13.8013C8.60433 13.8872 8.82275 13.9302 9.08057 13.9302C9.36702 13.9302 9.60872 13.8854 9.80566 13.7959C10.0026 13.7028 10.1548 13.5632 10.2622 13.377C10.3696 13.1872 10.4269 12.9455 10.4341 12.6519Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1016_39100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClientScript);
export default __webpack_public_path__ + "static/media/ic_client_script.fc8a3c9d07cd13d9d5e2a645cb30d6d5.svg";
export { ForwardRef as ReactComponent };